import { cn } from '@/lib/cn';

/**
 * K-Quest logo. Pixel block + display K, gold sparkle.
 * Renders crisp at any size.
 */
export function Logo({ className, size = 'md' }: { className?: string; size?: 'sm' | 'md' | 'lg' }) {
  const px = { sm: 28, md: 36, lg: 48 }[size];
  return (
    <div className={cn('flex items-center gap-2.5 select-none', className)}>
      <div className="relative">
        <div className="absolute inset-0 bg-enchant-grad rounded-sm blur-md opacity-60" />
        <div
          className="relative flex items-center justify-center font-press text-base text-kquest-100 bg-kquest-800 border-2 border-kquest-500"
          style={{
            width: px,
            height: px,
            boxShadow: 'inset 0 -3px 0 0 rgba(0,0,0,0.4), inset 0 3px 0 0 rgba(255,255,255,0.08)',
          }}
        >
          K
        </div>
      </div>
      <span className="font-pixel text-xl font-semibold tracking-tight leading-none">
        K-<span className="text-gradient-enchant">Quest</span>
      </span>
    </div>
  );
}
